import React from "react";
import { Dropdown } from "antd";
import { DownIcon } from "../../icons/js/DownIcon";

/**
 * Generic inline dropdown styled to match the dashboard "brand link" pattern:
 * label + down-caret, rendered inline with surrounding text (e.g. "Created on ▾").
 *
 * Fully reusable — pass any options array. Typical use cases:
 *  - Created on / Due on
 *  - Appointment / Opportunity
 *  - Appointment / Lead Opportunity / Response
 *
 * @param {{
 *   value: string,
 *   onChange: (value: string) => void,
 *   options: Array<{ label: string, key: string }>,
 *   placeholder?: string,
 *   className?: string,
 * }} props
 *
 * @example
 * <InlineDropdown
 *   value={dateBasis}
 *   onChange={setDateBasis}
 *   options={[
 *     { label: "Created on", key: "created_date" },
 *     { label: "Due on", key: "due_date" },
 *   ]}
 * />
 */
const InlineDropdown = ({ value, onChange, options = [], placeholder = "", className = "" }) => {
  const selectedLabel = options.find(opt => opt.key === value)?.label || placeholder;

  return (
    <Dropdown
      menu={{
        items: options,
        onClick: e => onChange?.(e.key),
      }}
    >
      <span className={`flex items-center gap-1 cursor-pointer text-brand-500 ${className}`}>
        {selectedLabel}
        <DownIcon />
      </span>
    </Dropdown>
  );
};

export default InlineDropdown;
